<form class="d-sm-flex align-items-center" *ngIf="account$ | async as account">
  <img
    style="width: 40px; height: 40px"
    class="me-2 d-inline d-lg-none d-xl-inline"
    (dblclick)="toggleHiddenAdminFeatures()"
    src="{{ account.profileImageUrl }}"
    alt="{{ account.name }}'s profilbild" />

  <small class="text-muted text-primary align-middle">
    <div ngbDropdown class="d-inline d-sm-block">
      <button type="button" class="btn btn-link p-0 text-start" id="accountMenu" ngbDropdownToggle>
        {{ account.name }}
      </button>
      <div ngbDropdownMenu aria-labelledby="accountMenu" class="dropdown-menu-end">
        <button ngbDropdownItem class="text-primary" [routerLink]="['/profile']">
          <span class="material-icons align-middle">person</span>
          Min profil
        </button>
        <div class="dropdown-divider"></div>
        <a target="_blank" ngbDropdownItem class="text-primary" href="https://support.klubbavgift.se/privacy-policy.html">
          Integritetspolicy
        </a>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem class="text-primary" (click)="logout()">
          <span class="material-icons align-middle">logout</span>
          Logga ut
        </button>
      </div>
    </div>
    <small class="text-muted text-smallest text-uppercase">{{ account.identityProvider.replace('.com', '') }}</small>
  </small>
</form>
